import { Mail, X } from 'lucide-react';

interface CheckEmailModalProps {
  email: string;
  onClose: () => void;
  onResend?: () => void;
}

export function CheckEmailModal({ email, onClose, onResend }: CheckEmailModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl max-w-md w-full p-8 text-center relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="w-16 h-16 mx-auto mb-6 bg-teal-100 dark:bg-teal-900/30 rounded-full flex items-center justify-center">
          <Mail className="w-8 h-8 text-teal-600 dark:text-teal-400" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Check Your Email
        </h1>

        <p className="text-gray-600 dark:text-gray-400 mb-2">
          We've sent a verification link to:
        </p>

        <p className="text-teal-600 dark:text-teal-400 font-semibold mb-6">
          {email}
        </p>

        <div className="bg-teal-50 dark:bg-teal-900/20 rounded-xl p-4 mb-6">
          <p className="text-sm text-teal-700 dark:text-teal-300">
            Click the link in your email to verify your account and activate your postcode identity.
          </p>
        </div>

        <p className="text-gray-500 dark:text-gray-500 text-sm mb-6">
          Didn't receive the email? Check your spam folder or{' '}
          {onResend ? (
            <button
              onClick={onResend}
              className="text-teal-600 hover:text-teal-700 dark:text-teal-400 font-medium"
            >
              click here to resend
            </button>
          ) : (
            <span className="text-teal-600 dark:text-teal-400">try again in a few minutes</span>
          )}
        </p>

        <button
          onClick={onClose}
          className="w-full py-3 px-4 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 font-semibold rounded-xl hover:bg-gray-200 dark:hover:bg-gray-600 transition-all"
        >
          Got it
        </button>

        <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
          <p className="text-xs text-gray-500 dark:text-gray-500">
            Coordal - Location Infrastructure for Africa
          </p>
        </div>
      </div>
    </div>
  );
}
